import { MapContainer, TileLayer, Marker, useMapEvents, LocateUser } from "react-leaflet";
import { useState } from "react";
import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function LocationMarker({ location, setLocation }) {
  useMapEvents({
    click(e) {
      setLocation({
        lat: e.latlng.lat,
        lng: e.latlng.lng
      });
    }
  });

  return location ? (
    <Marker position={[location.lat, location.lng]} />
  ) : null;
}

export default function DeliveryMap({
  location,
  setLocation
}) {
  return (
    <MapContainer
      center={[-1.286389, 36.817223]}
      zoom={12}
      style={{
        height: "400px",
        width: "100%",
        borderRadius: "6px"
      }}
    >
      <TileLayer
        attribution="&copy; OpenStreetMap"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />


      <LocationMarker
        location={location}
        setLocation={setLocation}
      />
    </MapContainer>
  );
}